import axios from 'axios';

export const getStatistics = (query)=>axios.get(`/admin/statistics?range=${query}`);